import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
export default class MentionsDropdownItem extends Component {
  view(vnode) {
    const {
      mentionable,
      ...attrs
    } = this.attrs;
    const className = classList('MentionsDropdownItem', 'PostPreview', `MentionsDropdown-${mentionable.type()}`);
    return m("button", Object.assign({
      className: className,
      type: "button"
    }, attrs), m("span", {
      className: "PostPreview-content"
    }, vnode.children));
  }
}
flarum.reg.add('flarum-mentions', 'forum/components/MentionsDropdownItem', MentionsDropdownItem);